import React, { FC, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { v1 as uuidv1 } from "uuid";

import { LinkIcon, RafterDownIcon } from "@/assets/icons";
import { LinkToPartner } from "@/components/atoms";
import { useSecuredUrl } from "@/shared/hooks";
import { InsurerLink } from "@/shared/utils";

import { StyledLinkButtonDropdown, StyledLinkDropdownMenuItem, StyledLinkDropdownPopover } from "./styled";

type InsurerLinkDropdownProps = {
    insurerLinks: InsurerLink[];
    insurer: MyBrokerApi.Company;
    id: number;
};

const InsurerLinkDropdown: FC<InsurerLinkDropdownProps> = ({ insurerLinks, insurer, id }) => {
    const { t } = useTranslation();
    const menuID = uuidv1();
    const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);
    const [openLink, setOpenLink] = useState(null);
    const insurerName = insurer.name;

    const { onSecureUrlClick } = useSecuredUrl();

    const onClickLinkButtonDropdown = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        setAnchorEl(null);
        event.stopPropagation();
        event.preventDefault();
    };

    const onClickLink = (event, link: string) => {
        setAnchorEl(null);
        setOpenLink(link);
        event.stopPropagation();
        event.preventDefault();
    };

    useEffect(() => {
        if (openLink) {
            onSecureUrlClick(openLink);
            setOpenLink(null);
        }
    }, [openLink]);

    if (!insurerLinks.length) {
        return <></>;
    }

    if (insurerLinks.length === 1) {
        return <LinkToPartner id={id} key={`secured-url-${id}`} insurerLink={insurerLinks[0]} />;
    }

    return (
        <>
            <StyledLinkButtonDropdown
                aria-haspopup="true"
                aria-expanded={!!anchorEl}
                aria-owns={menuID}
                onClick={onClickLinkButtonDropdown}
                $active={!!anchorEl}
                data-testid={`item-button-dropdown-jump_${id}`}
            >
                <LinkIcon alt="Link Icon" />
                {t("ContractsItem.LinkButtonDrodpown", {
                    insurer: insurerName,
                })}
                <RafterDownIcon style={!anchorEl ? null : { transform: "rotate(180deg)" }} />
            </StyledLinkButtonDropdown>
            <StyledLinkDropdownPopover id={menuID} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                {insurerLinks.map(({ link, label }) => (
                    <StyledLinkDropdownMenuItem
                        key={link}
                        data-testid={`item-jump_-${link}`}
                        onClick={(e) => onClickLink(e, link)}
                    >
                        <LinkIcon alt="Link Icon" />
                        {label}
                    </StyledLinkDropdownMenuItem>
                ))}
            </StyledLinkDropdownPopover>
        </>
    );
};
export default InsurerLinkDropdown;
